module.exports = __webpack_public_path__ + "img/電気回路_4_1_1.240e3107.png";